import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Pagination } from '../../../../common/pagination'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { Z_INDEX } from '../../../../utils/common'
import { LinkComponent } from '../../../common/html/LinkComponent'
import {
  changeFilterTrial,
  getDataFromReduxTrialList,
  idsTableTrialList,
  selectFilterTrial,
  selectTotalTrial,
} from '../store/slice'

export const TrialListPopup = ({ isShow, handleClose }) => {
  const dispatch = useDispatch()

  const { height } = useViewport()

  const ids = useSelector(idsTableTrialList)
  const filter = useSelector(selectFilterTrial)
  const total = useSelector(selectTotalTrial)

  const setPage = (page) => {
    dispatch(
      changeFilterTrial({
        page,
      }),
    )
  }

  const setPageSize = (pageSize) => {
    dispatch(
      changeFilterTrial({
        page: 1,
        pageSize,
      }),
    )
  }

  const renderPagination = () => {
    return (
      <Pagination
        page={filter.page}
        pageSize={filter.pageSize}
        total={total}
        setPage={setPage}
        setPageSize={setPageSize}
        zIndex={Z_INDEX.MODAL + 1}
        className="pt1"
      />
    )
  }

  return (
    <PopupAction
      title="dashboard.currentPlan.trialList"
      isShow={isShow}
      handleClose={handleClose}
      btnSubmit={{
        label: 'dashboard.suggestDetail.cancel',
        event: handleClose,
        isI18n: true,
      }}
      appendStyle={{
        width: 800,
        backgroundColor: '#F3F3F3',
        borderRadius: 4,
        padding: '20px 20px 8px 20px',
      }}
    >
      <Table
        ids={ids}
        getDataFromRedux={getDataFromReduxTrialList}
        schema={[
          {
            colId: 'orgValue',
            title: (
              <Element className="textCapitalize">
                <Translate value="dashboard.suggestDetail.companyName" />
              </Element>
            ),
            render: (val) => {
              const { organizationName, organizationId } = val
              return (
                <LinkComponent
                  href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${organizationId}`}
                  style={{ color: '#2C73E8' }}
                >
                  <TextEllipsisStaticLine
                    text={organizationName}
                    lineClamp={1}
                    isI18n={false}
                    zIndexTooltip={Z_INDEX.MODAL + 1}
                  />
                </LinkComponent>
              )
            },
          },
        ]}
        autoHeightMax={height * 0.7}
        renderPagination={renderPagination}
      />
    </PopupAction>
  )
}
